import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './ShowThumb.module.css';
import ActionsBox from './ActionsBox/ActionsBox';
import { SHOW, MOVIE_SHOW } from '../../constants/routes';
import PreloadImage from '../UI/PreloadImage/PreloadImage';
import { PreloadLinkShow } from '../UI/PreloadLink/Show/Show';
import Kinostyles from '../Util/AutokinoStylesComponent.module.css';
import kwd_info_box from '../../assets/images/autokino/kinoprogramm/KWD_Hinweisbox1.svg';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/button';

import { connect } from 'react-redux';
import { fetchProductImage } from '../../store/actions';
import { MOVIE_DETAIL } from '../../constants/routes';
import { Image } from 'react-bootstrap';

const ShowThumb = props => {
  const [showKWDInfo, setShowKWDInfo] = useState(false);
  const handleClose = () => showKWDInfoBox(false);
  const {
    item: {
      date,
      location,
      timeSlot,
      movie,
      showName,
      products,
      publicAvailable,
      showId,
      time,
      upcoming,
      ribbonType,
      soldOut,
      futureSales,
      urlIdentifier,
      displayMoviePageBeforeShowDetail,
      movieUrlIdentifier,
      countFutureShowsForMovie,
      fomoStatus,
      showType
    },
    handleShow = props.handleShow,
    dateString = props.dateString,
  } = props;

  const {
    inWishlist,
    onAddToCart,
    addingToCart,
    inCart,
    toggleWishlist,
    togglingWishlist,
  } = props;

  const getDetailPath = () => {
    /*return countFutureShowsForMovie > 0
      ? MOVIE_DETAIL + '/' + movieUrlIdentifier
      : urlIdentifier
      ? MOVIE_SHOW + '/' + urlIdentifier
      : SHOW + '/' + showId;*/
    return urlIdentifier
      ? MOVIE_SHOW + '/' + urlIdentifier
      : SHOW + '/' + showId;
  };
  const showKWDInfoBox = (show) => {
    setShowKWDInfo(show);
  }

  const getFomoText = () => {
    var text = '';
    if (fomoStatus === 1) {
      text = 'Weniger als 20 Tickets verfügbar';
    } else if (fomoStatus === 2) {
      text = 'Weniger als 10 Tickets verfügbar';
    } else if (fomoStatus === 3) {
      text = 'Weniger als 5 Tickets verfügbar';
    } else if (fomoStatus === 4) {
      text = 'Nur noch 2 Tickets verfügbar';
    } else if (fomoStatus === 5) {
      text = 'Nur noch 1 Ticket verfügbar';
    }
    return text;
  };

  return (
    <div id={'show_' + showId} name={'show_' + showId}>
      <div
        className={
          Kinostyles.ListHeadlineCenterUnderline + ' mb-2 mt-2 d-lg-none'
        }
      >
        <hr />
        {dateString}
      </div>
      {showType == 'kino_past' ? (
        <>
          <a href='' onClick={(e) => {
            e.preventDefault();
            showKWDInfoBox(true);
          }}>
            <div className='ps-4 pe-4 mb-2'>
              <Image src={kwd_info_box} fluid />
            </div>
          </a>
        </>
      ) : ''}

      <div className={Kinostyles.ListMovieTitle}>
        {showName != null ? showName : movie.movieName}
      </div>
      <div>
        <div className={styles.ImageBox}>
          {!soldOut && !futureSales && showId !== 207 ? (
            <PreloadLinkShow
              to={getDetailPath()}
              id={showId}
              title={
                showName != null
                  ? showName
                  : movie != null
                    ? movie.movieName
                    : location + ' | ' + date + ' | ' + time
              }
            >
              <PreloadImage
                src={movie != null ? movie.imagePath : ''}
                //src={imagePath}//{imagePath}
                alt={movie.movieName}
                className={styles.Image}
                loadingClass={styles.LoadingImage}
              />
            </PreloadLinkShow>
          ) : (
            <PreloadImage
              src={movie != null ? movie.imagePath : ''}
              //src={imagePath}//{imagePath}
              alt={movie.movieName}
              className={styles.Image}
              loadingClass={styles.LoadingImage}
            />
          )}
        </div>
        <div>
          {!soldOut ? (
            <div className={styles.fomoBox}>{getFomoText()}&nbsp;</div>
          ) : (
            ''
          )}
          <div className={Kinostyles.CenterContent + ' mt-2'}>
            {
              !date.endsWith('2099') ? (
                !soldOut ? (
                  !futureSales ? (
                    <ActionsBox
                      additionalClassName={styles.ActionsBox}
                      addedToCart={onAddToCart}
                      addingToCart={addingToCart}
                      inCart={inCart}
                      showId={showId}
                      linkTarget={getDetailPath()}
                      urlIdentifier={urlIdentifier}
                      toggledWishlist={toggleWishlist}
                      togglingWishlist={togglingWishlist}
                      inWishlist={inWishlist}
                    />
                  ) : !futureSales && countFutureShowsForMovie > 0 ? (
                    <ActionsBox
                      additionalClassName={styles.ActionsBox}
                      addedToCart={onAddToCart}
                      addingToCart={addingToCart}
                      inCart={inCart}
                      showId={showId}
                      linkTarget={MOVIE_DETAIL + '/' + movieUrlIdentifier}
                      urlIdentifier={urlIdentifier}
                      toggledWishlist={toggleWishlist}
                      togglingWishlist={togglingWishlist}
                      inWishlist={inWishlist}
                      linkText="Details zum Film"
                    />
                  ) : (
                    <button className="btn btn-first btn-disabled">
                      Verkauf startet in Kürze
                    </button>
                  )
                ) : countFutureShowsForMovie > 0 ? (
                  <>
                    <button className="btn btn-first btn-disabled">
                      Ausverkauft
                    </button>
                    <br />
                    <br />
                    <ActionsBox
                      additionalClassName={'btn btn-first btn-disabled'}
                      addedToCart={onAddToCart}
                      addingToCart={addingToCart}
                      inCart={inCart}
                      showId={showId}
                      linkTarget={MOVIE_DETAIL + '/' + movieUrlIdentifier}
                      urlIdentifier={urlIdentifier}
                      toggledWishlist={toggleWishlist}
                      togglingWishlist={togglingWishlist}
                      inWishlist={inWishlist}
                      linkText="Weitere Termine"
                    />
                  </>
                ) : (
                  <button className="btn btn-first btn-disabled">
                    Ausverkauft
                  </button>
                )
              ) : (
                <button
                  onClick={e => {
                    handleShow(true, movie.movieId);
                  }}
                  className="btn btn-first"
                >
                  Vormerken
                </button>
              )
            }
          </div>
          <br />
        </div>
      </div>
      <Modal show={showKWDInfo} onHide={handleClose}>
        <Modal.Header className={styles.ModalHeader}>
          <Modal.Title>
            <b>Kurzinformation zu Kino wie Damals Vorstellungen</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.ModalBody}>
          <ul>
            <li>
              <b>ermäßigter Ticketpreis</b> (nur bei Online-Buchung)
            </li>
            <li>
              freie Parkplatzwahl (keine liefern zu den Autos)
            </li>
            <li>
              vollständige Speisekarte (Kinosnacks + Cocktails + div. Hot Dog´s)
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            type="submit"
            onClick={() => showKWDInfoBox(false)}
            className={'btn btn-first'}
          >
            Schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

/*return (
    <div className={styles.Show}>
      <div className={styles.ShowInner}>
        <div className={styles.ImageBox}>
          <Ribbon type={ribbonType} />
          <PreloadLinkShow
            to={`${SHOW}/${showId}`}
            id={showId}
            title={
              movie != null
                ? movie.movieName
                : location + ' | ' + date + ' | ' + time
            }
          >
            <PreloadImage
              src={movie != null ? movie.imagePath : ''}
              //src={imagePath}//{imagePath}
              alt={movie.movieName}
              className={styles.Image}
              loadingClass={styles.LoadingImage}
            />
          </PreloadLinkShow>
        </div>
        <div className={styles.Info}>
          <div>{date}</div>
          <h3 className={styles.Title}>{movie.movieName}</h3>
          <div>Einlass: {timeSlot}</div>
          <div>Start:{time}</div>
        </div>

        <ActionsBox
          additionalClassName={styles.ActionsBox}
          addedToCart={onAddToCart}
          addingToCart={addingToCart}
          inCart={inCart}
          showId={showId}
          toggledWishlist={toggleWishlist}
          togglingWishlist={togglingWishlist}
          inWishlist={inWishlist}
        />
      </div>
    </div>
  );
}; */

ShowThumb.propTypes = {
  inWishlist: PropTypes.bool,
  onAddToCart: PropTypes.func,
  addingToCart: PropTypes.bool,
  inCart: PropTypes.bool,
  toggleWishlist: PropTypes.func,
  togglingWishlist: PropTypes.bool,
  item: PropTypes.object,
  handleShow: PropTypes.func,
  dateString: PropTypes.string,
};

// const mapStateToProps = state => {

//   return {

//   };
// };

export default connect(
  null,
  { fetchProductImage }
)(ShowThumb);
// export default ShowThumb;
